'use strict';

require('./salary-summary.scss');

module.exports = {
  template: require('./salary-summary.html'),
  controller: require('./salary-summary.controller'),
  controllerAs: 'vm',

  bindings: {
    me: '<',
    data: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-summary/index.js
 ** module id = 219
 ** module chunks = 0
 **/